import { render, staticRenderFns } from "./tUsers.vue?vue&type=template&id=32f9c42b&scoped=true"
import script from "./tUsers.vue?vue&type=script&lang=js"
export * from "./tUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f9c42b",
  null
  
)

export default component.exports